const ProductArticles = class {
  $parent = null;
  $productCards = null;
  $desktopMenus = [];
  $mobileMenus = [];
  $activeDesktopMenu = null;
  $activeMobileMenu = null;
  $articleContents = [];

  constructor(parent) {
    this.$parent = parent;
    this.init();
  }

  init() {
    if (!this.$parent) {
      return;
    }

    this.initSwiper();
    this.initProductCard();
    this.initArticleMenu();
    this.initDesktopMenu();
  }

  initSwiper() {
    const swiperElement = this.$parent.querySelector('.as-swiper');
    if (!swiperElement) {
      return;
    }

    new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: true,
      watchSlidesProgress: true,
      watchSlidesVisibility: true
    });

    this.handleSwiperResize();
    window.addEventListener('resize', () => {
      this.handleSwiperResize();
    });
  }

  handleSwiperResize() {
    const swiperWrapper = this.$parent.querySelector('.as-swiper-wrapper');
    if (!swiperWrapper) {
      return;
    }

    const swiperSlides = this.$parent.querySelectorAll('.as-swiper-slide');
    if (!swiperSlides.length) {
      return;
    }

    const swiperWrapperWidth = swiperWrapper.clientWidth;
    const swiperSlideWidth = swiperSlides[0].clientWidth * swiperSlides.length;
    if (swiperSlideWidth > swiperWrapperWidth) {
      swiperWrapper.classList.remove('justify-content-center');
    } else {
      swiperWrapper.classList.add('justify-content-center');
    }
  }

  initProductCard() {
    this.$productCards = this.$parent.querySelectorAll('.as-product-card');
    this.$productCards.forEach((card) => {
      card.addEventListener('click', (event) => {
        event.preventDefault();
        this.$productCards.forEach((item) => item.classList.remove('is-active'));
        card.classList.add('is-active');
        this.setActiveMenuByProductId(card.dataset.productId);
      });
    });
  }

  initArticleMenu() {
    this.$desktopMenus = this.$parent.querySelectorAll('.as-article-menu');
    this.$mobileMenus = this.$parent.querySelectorAll('.as-mobile-article-menu');
    this.$articleContents = this.$parent.querySelectorAll('.article-content');

    if (!this.$desktopMenus.length && !this.$mobileMenus.length) {
      return;
    }

    const defaultProductId = this.$parent.querySelector('.as-product-card.is-active')?.dataset.productId;
    this.setActiveMenuByProductId(defaultProductId);
    this.bindDesktopMenuEvents();
    this.bindMobileMenuEvents();
    this.bindOutsideClick();
  }

  setActiveMenuByProductId(productId) {
    this.setActiveDesktopMenuByProductId(productId);
    this.setActiveMobileMenuByProductId(productId);
  }

  setActiveDesktopMenuByProductId(productId) {
    if (!this.$desktopMenus.length) {
      return;
    }

    let targetMenu = null;
    this.$desktopMenus.forEach((menu) => {
      menu.classList.add('d-none');
      if (productId && menu.dataset.productId === productId) {
        targetMenu = menu;
      }
    });

    if (!targetMenu) {
      targetMenu = this.$desktopMenus[0];
    }

    targetMenu.classList.remove('d-none');
    this.$activeDesktopMenu = targetMenu;

    const activeItem = targetMenu.querySelector('.as-article-menu-item.is-active') || targetMenu.querySelector('.as-article-menu-item');
    if (!activeItem) {
      return;
    }

    targetMenu.querySelectorAll('.as-article-menu-item').forEach((button) => {
      button.classList.toggle('is-active', button === activeItem);
    });

    this.renderArticleById(activeItem.dataset.articleId);
  }

  setActiveMobileMenuByProductId(productId) {
    if (!this.$mobileMenus.length) {
      return;
    }

    let targetMenu = null;
    this.$mobileMenus.forEach((menu) => {
      menu.classList.add('d-none');
      menu.style.paddingBottom = '';
      if (productId && menu.dataset.productId === productId) {
        targetMenu = menu;
      }
    });

    if (!targetMenu) {
      targetMenu = this.$mobileMenus[0];
    }

    targetMenu.classList.remove('d-none');
    this.$activeMobileMenu = targetMenu;
    this.resetMobileMenuState(targetMenu);

    const activeItem = targetMenu.querySelector('.as-mobile-menu-article-item.is-active') || targetMenu.querySelector('.as-mobile-menu-article-item');
    if (!activeItem) {
      return;
    }

    targetMenu.querySelectorAll('.as-mobile-menu-article-item').forEach((button) => {
      button.classList.toggle('is-active', button === activeItem);
    });

    this.setMobileToggleLabel(targetMenu, activeItem.textContent.trim());
    this.renderArticleById(activeItem.dataset.articleId);
  }

  bindDesktopMenuEvents() {
    this.$desktopMenus.forEach((menu) => {
      menu.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-group-trigger]');
        if (trigger) {
          const group = trigger.closest('.as-article-menu-group');
          const isOpen = group.classList.contains('is-open');
          // menu.querySelectorAll('.as-article-menu-group').forEach((item) => item.classList.remove('is-open'));
          if (!isOpen) {
            group.classList.add('is-open');
          } else {
            group.classList.remove('is-open');
          }
          return;
        }

        const item = event.target.closest('.as-article-menu-item[data-article-id]');
        if (!item) {
          return;
        }

        menu.querySelectorAll('.as-article-menu-item').forEach((button) => {
          button.classList.toggle('is-active', button === item);
        });

        // 联动移动端
        if (this.$activeMobileMenu) {
          const mobileMenuItems = this.$activeMobileMenu.querySelectorAll('.as-mobile-menu-article-item');
          mobileMenuItems.forEach((button) => {
            button.classList.toggle('is-active', button.dataset.articleId === item.dataset.articleId);
          });
        }

        this.renderArticleById(item.dataset.articleId);
        this.scrollToArticleTop();
      });
    });
  }

  bindMobileMenuEvents() {
    this.$mobileMenus.forEach((menu) => {
      menu.addEventListener('click', (event) => {
        const toggleButton = event.target.closest('[data-mobile-menu-toggle]');
        if (toggleButton) {
          this.toggleMobileDropdown(menu);
          return;
        }

        const groupButton = event.target.closest('[data-mobile-group-target]');
        if (groupButton) {
          this.openMobileGroup(menu, groupButton.dataset.mobileGroupTarget);
          return;
        }

        const backButton = event.target.closest('[data-mobile-menu-back]');
        if (backButton) {
          this.backToMobileRoot(menu);
          return;
        }

        const articleItem = event.target.closest('.as-mobile-menu-article-item[data-article-id]');
        if (!articleItem) {
          return;
        }

        menu.querySelectorAll('.as-mobile-menu-article-item').forEach((button) => {
          button.classList.toggle('is-active', button === articleItem);
        });

        // 联动桌面端
        const desktopMenuItems = this.$activeDesktopMenu.querySelectorAll('.as-article-menu-item');
        desktopMenuItems.forEach((button) => {
          button.classList.toggle('is-active', button.dataset.articleId === articleItem.dataset.articleId);
        });

        this.setMobileToggleLabel(menu, articleItem.textContent.trim());
        this.closeMobileDropdown(menu);
        this.renderArticleById(articleItem.dataset.articleId);
      });
    });
  }

  bindOutsideClick() {
    document.addEventListener('click', (event) => {
      if (!this.$parent.contains(event.target)) {
        this.$mobileMenus.forEach((menu) => this.closeMobileDropdown(menu));
        return;
      }

      this.$mobileMenus.forEach((menu) => {
        const dropdown = menu.querySelector('[data-mobile-menu-dropdown]');
        if (!dropdown || dropdown.classList.contains('d-none')) {
          return;
        }
        if (!menu.contains(event.target)) {
          this.closeMobileDropdown(menu);
        }
      });
    });
  }

  toggleMobileDropdown(menu) {
    const dropdown = menu.querySelector('[data-mobile-menu-dropdown]');
    if (!dropdown) {
      return;
    }

    const isClosed = dropdown.classList.contains('d-none');
    if (isClosed) {
      dropdown.classList.remove('d-none');
      dropdown.classList.add('is-open');
      menu.classList.add('is-open');
      this.backToMobileRoot(menu);
    } else {
      this.closeMobileDropdown(menu);
    }
  }

  openMobileGroup(menu, groupIndex) {
    const dropdown = menu.querySelector('[data-mobile-menu-dropdown]');
    if (!dropdown) {
      return;
    }

    dropdown.classList.remove('d-none');
    dropdown.classList.add('is-open');
    menu.classList.add('is-open');
    dropdown.classList.add('is-level-2');
    dropdown.dataset.activeGroup = groupIndex;

    menu.querySelectorAll('.as-mobile-menu-group-panel').forEach((panel) => {
      panel.classList.toggle('d-none', panel.dataset.mobileGroupPanel !== groupIndex);
    });
  }

  backToMobileRoot(menu) {
    const dropdown = menu.querySelector('[data-mobile-menu-dropdown]');
    if (!dropdown) {
      return;
    }

    dropdown.classList.remove('is-level-2');
    delete dropdown.dataset.activeGroup;
    menu.querySelectorAll('.as-mobile-menu-group-panel').forEach((panel) => {
      panel.classList.add('d-none');
    });
  }

  closeMobileDropdown(menu) {
    const dropdown = menu.querySelector('[data-mobile-menu-dropdown]');
    if (!dropdown) {
      return;
    }

    dropdown.classList.add('d-none');
    dropdown.classList.remove('is-open');
    menu.classList.remove('is-open');
    this.backToMobileRoot(menu);
  }

  setMobileToggleLabel(menu, text) {
    const label = menu.querySelector('[data-mobile-menu-toggle-label]');
    if (!label) {
      return;
    }
    label.textContent = text;
    menu.classList.add('has-selection');
  }

  resetMobileMenuState(menu) {
    if (!menu) {
      return;
    }
    this.closeMobileDropdown(menu);
  }

  renderArticleById(articleId) {
    if (!this.$articleContents.length || !articleId) {
      return;
    }

    let matchedIndex = -1;
    this.$articleContents.forEach((article, index) => {
      const isMatched = article.dataset.articleId === articleId;
      if (isMatched && matchedIndex === -1) {
        matchedIndex = index;
      }
    });

    const visibleIndex = matchedIndex !== -1 ? matchedIndex : 0;
    this.$articleContents.forEach((article, index) => {
      article.classList.toggle('d-none', index !== visibleIndex);
    });
  }

  scrollToArticleTop() {
    const articleWrapper = this.$parent.querySelector('.article-wrapper');
    if (!articleWrapper) {
      return;
    }

    const header = document.querySelector('.header-wrapper');
    const headerOffset = header ? header.offsetHeight : 0;
    const targetTop = articleWrapper.getBoundingClientRect().top + window.pageYOffset - headerOffset - 12;

    window.requestAnimationFrame(() => {
      window.scrollTo({
        top: Math.max(targetTop, 0),
        behavior: 'smooth'
      });
    });
  }

  initDesktopMenu() {
    const desktopMenu = this.$parent.querySelector('.as-menu-wrapper');
    const header = document.querySelector('.header-wrapper');
    if (!header) {
      return;
    }
    if (!desktopMenu) {
      return;
    }
    desktopMenu.style.top = header.offsetHeight + 'px';
    desktopMenu.style.maxHeight = 'calc(100vh - ' + header.offsetHeight + 'px)';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const productArticles = document.querySelectorAll('.as-product-articles');
  productArticles.forEach((item) => {
    new ProductArticles(item);
  });
});
